import React from "react";
import { Modal } from "antd";
import Scrollbars from "react-custom-scrollbars-2";
import SentimentDocs from "../SentimentWidget/SentimentDocs";

const MetaFilterModal = ({ visible, onClose, content, additionalFilter }) => {
    return (
        <Modal
            title="Concepts:"
            visible={visible}
            onCancel={onClose}
            footer={null}
        >
            <Scrollbars
                style={{
                    maxWidth: "100%",
                    height: "100%",
                    minHeight: "500px",
                }}
            >
                <ul>
                    {content && content.length > 0 ? (
                        content.map((item, index) => (
                            <li key={item.name}>
                                <SentimentDocs
                                    additionalFilter={additionalFilter}
                                    concept={item}
                                />
                            </li>
                        ))
                    ) : (
                        <p>No data available</p>
                    )}
                </ul>
            </Scrollbars>
        </Modal>
    );
};

export default MetaFilterModal;
